export default "__VITE_ASSET__400604f4__"